import { Image, Link, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowDeratizacijaEvdListaDefinisanihTacakaHeader: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  slikaDeklaracije: string;
}> = ({ datum, fullname, potpis, slikaDeklaracije }) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{potpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{slikaDeklaracije}</Text>
    </View>
  </View>
);

export const TableRowDeratizacijaEvdListaDefinisanihTacaka: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  slikaDeklaracije?: string;
  slikaRes: string;
}> = ({ datum, fullname, potpis, slikaDeklaracije, slikaRes }) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image style={[styles.tableCell, styles.signatureImage]} src={potpis} />
      )}
    </View>
    <View style={styles.tableCol}>
      {slikaDeklaracije && (
        <Link
          src={slikaDeklaracije}
          style={{ ...styles.tableCell, ...styles.link }}
        >
          {slikaRes}
        </Link>
      )}
    </View>
  </View>
);
